import React, { useState } from "react";
import { useAuth } from "../../auth/AuthHandler";
import '../../styling/BORemark.css';
import { useApiClient } from "../../service/API";
import NotificationModal from "./NotificationModal";
import { getApiErrorMessage } from "../../service/errorHandler";

export default function BORemark({ ticket }) {
    const { userEmail, userRoles } = useAuth();
    const [boremark, setBoremark] = useState(ticket.boremark || '');
    const [notificationMessage, setNotificationMessage] = useState('');
    const [showNotification, setShowNotification] = useState(false);
    const apiClient = useApiClient();

    const handleChange = (e) => {
    setBoremark(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (boremark.trim() === '') {
            alert("Remark cannot be empty.");
            return;
        }
        
        try {
            // Send the patch request for approval
            const response = await apiClient.patch(`/tickets/update-boremark/${ticket.id}`, {
                boremark: boremark
              });
              
            // After successful approval, trigger the ticket list refresh
            if(response.status === 200){
                setNotificationMessage(`Ticket ${ticket.id} updated successful to DONE!`);
            }
        } catch (error) {
            // Handle error if needed (optional: display an error message)
            setNotificationMessage(getApiErrorMessage(error, "Failed to update BO remark."));
        } finally {
            // Simulate submission
            console.log("Submitted BO Remark:", boremark);
            setShowNotification(true);
        }
    };

    const handleModalClose = () => {
        setShowNotification(false);
    };

    return (
    <div className="boremark-container">
        <h2 className="boremark-title">BO Remark</h2>
        <textarea
        name="boremark"
        id="inputRemark"
        className="boremark-textarea"
        rows="4"
        placeholder="Enter your remark here..."
        value={boremark}
        onChange={handleChange}
        style={{ whiteSpace: 'pre-wrap' }}
        disabled={!['BOUSER', 'ADMIN'].some(role => userRoles.includes(role)) && userEmail !== ticket.assignedTo}
        />
        <button className="boremark-submit-btn" onClick={handleSubmit} disabled={!['BOUSER', 'ADMIN'].some(role => userRoles.includes(role)) && userEmail !== ticket.assignedTo}>
        Submit
        </button>
        <NotificationModal
        show={showNotification}
        message={notificationMessage}
        onClose={handleModalClose}
      />
    </div>
    );
}
